module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n/en/passbooks.json
// module id = 2401
// module chunks = 1